"use strict";

// Пока модальных окон на чистом css, без fancybox.

var LINK_SELECTOR = ".js-modal";
var CLOSE_SELECTOR = "[data-action='close']";

function init(id) {
    var modal = document.querySelector(id);
    var close = modal.querySelector(CLOSE_SELECTOR);
    if (close) {
        close.addEventListener("click", function (e) {
            hide(modal);
            e.preventDefault();
        });
    }
    return modal;
}

function show(modal) {
    document.body.style.overflow = "hidden";
    modal.style.display = "flex";
    modal.style.pointerEvents = "auto";
    modal.style.opacity = 1;
}

function hide(modal) {
    document.body.style.removeProperty("overflow");
    modal.style.display = "none";
    modal.style.pointerEvents = "none";
    modal.style.opacity = 0;
}

function attachTo(link) {
    var modal = init(link.hash);
    link.addEventListener("click", function (e) {
        show(modal);
        e.preventDefault();
    });
    if (window.location.hash === link.hash) {
        show(modal);
    }
}

function attach() {
    var links = document.querySelectorAll(LINK_SELECTOR);
    links.forEach(function (link) {
        attachTo(link);
    });
}

export default {
    attach: attach,
};
